module.exports = __webpack_public_path__ + "static/media/webpage-before.204141c7.jpg";